import Vue from 'vue'
import axios from 'axios'
// import { GET_CATEGORY, GET_CATEGORY_STORE } from '@/constants/path'
import store from '@/store'
import camelcaseKeys from 'camelcase-keys'
const ignoreErrorPath = []
import { LOGIN, PRODUCT_QUOTA_TIME } from '@/constants/path'

export default function setup() {
  axios.defaults.baseURL = process.env.VUE_APP_API_URL

  axios.interceptors.request.use(
    function (config) {
      config.headers.Accept = '*/*'
      const token = store?.getters['auth/token'] ?? ''
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    function (err) {
      return Promise.reject(err)
    },
  )
}

export const api = async (path, method, param, options) => {
  store.dispatch('loading/setLoading', true)
  if (path.includes('backoffice/')) {
    axios.defaults.baseURL = process.env.VUE_APP_BACK_OFFICE_URL
  } else {
    axios.defaults.baseURL = process.env.VUE_APP_API_URL
  }

  const met = method.toLowerCase()
  try {
    let result
    if (met === 'get') {
      result = camelcaseKeys(await axios.get(path, param, options), {
        deep: true,
      })
    } else if (met === 'post') {
      result = await new Promise((resolve, reject) => {
        camelcaseKeys(
          axios
            .post(path, param, options)
            .then((res) => resolve(res))
            .catch((err) => reject(err)),
          {
            deep: true,
          },
        )
      })
    } else if (met === 'put') {
      result = await new Promise((resolve, reject) => {
        camelcaseKeys(
          axios
            .put(path, param, options)
            .then((res) => resolve(res))
            .catch((err) => reject(err)),
          {
            deep: true,
          },
        )
      })
    } else if (met === 'delete') {
      result = await camelcaseKeys(
        axios.delete(path, param, options),
        {
          deep: true,
        },
      )
    } else if (met === 'getblob') {
      result = await axios.get(path, {
        ...param,
        responseType: 'blob',
      })
    }
    if (
      met !== 'get' &&
      path !== LOGIN &&
      path !== PRODUCT_QUOTA_TIME
    )
      Vue.$toast.success(result?.data?.message || 'ทำรายการสำเร็จ')
    store.dispatch('loading/setLoading', false)
    return result
  } catch (e) {
    const isJsonBlob = (data) =>
      data instanceof Blob && data.type === 'application/json'
    const responseData = isJsonBlob(e.response?.data)
      ? await e.response?.data?.text()
      : e.response?.data || {}
    const responseJson =
      typeof responseData === 'string'
        ? JSON.parse(responseData)
        : responseData

    store.dispatch('loading/setLoading', false)
    if (401 === responseJson.status) {
      const message =
        responseJson?.message || e.response?.data?.message
      if (message && message.includes('2FA verification required')) {
        const phone = responseJson?.data?.phone || ''
        store.commit('auth/SET_REQUIRES_2FA', true)
        store.commit('auth/SET_USER_PHONE_FOR_2FA', phone)
        return Promise.reject(e)
      }
      store.dispatch('auth/logout')
    } else {
      if (
        !ignoreErrorPath.find((i) =>
          i.toLowerCase().includes(`${path}`),
        )
      ) {
        if (met !== 'get') Vue.$toast.error(e.response?.data?.message)
      }
    }
    return Promise.reject(e)
  }
}
